import { cx } from './cx';
import type { ShopInventoryStatus } from '@pc/db';

const STYLES: Record<ShopInventoryStatus, string> = {
  in_stock: 'bg-[#16742D14] text-[#16742D] border-[#16742D33]',
  low_stock: 'bg-[#A8451E14] text-[#A8451E] border-[#A8451E33]',
  out_of_stock: 'bg-paper-2 text-muted border-rule',
  preorder: 'bg-paper-3 text-ink border-rule-strong',
  discontinued: 'bg-paper-2 text-muted line-through border-rule',
};

const LABEL: Record<ShopInventoryStatus, string> = {
  in_stock: 'In stock',
  low_stock: 'Low stock',
  out_of_stock: 'Out of stock',
  preorder: 'Pre-order',
  discontinued: 'Discontinued',
};

export const INVENTORY_STATUSES: ReadonlyArray<{
  value: ShopInventoryStatus;
  label: string;
}> = (Object.entries(LABEL) as Array<[ShopInventoryStatus, string]>).map(
  ([value, label]) => ({ value, label }),
);

export interface InventoryBadgeProps {
  status: ShopInventoryStatus;
  className?: string;
}

export function InventoryBadge({ status, className }: InventoryBadgeProps) {
  return (
    <span
      className={cx(
        'inline-flex items-center px-2 py-0.5 text-[11px] tracking-wide uppercase border',
        STYLES[status],
        className,
      )}
    >
      {LABEL[status]}
    </span>
  );
}
